import { Helmet } from 'react-helmet-async';

interface PageHelmetProps {
  title: string;
  description: string;
}

export function PageHelmet({ title, description }: PageHelmetProps) {
  const fullTitle = `${title} | BeautyBookAI`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
}
